import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const row = (label, value) => (
  <div className="d-flex mb-2" style={{ fontSize: 14 }}>
    <div className="text-muted" style={{ width: 110, flexShrink: 0 }}>{label}</div>
    <div className="fw-medium">{value || <span className="text-muted">—</span>}</div>
  </div>
);

export default function DeliveryInfoModal({ order, onClose }) {
  if (!order) return null;

  const addressLines = [order.deliveryAddressLine1, order.deliveryAddressLine2].filter(Boolean).join(', ');
  const cityStateZip = [order.deliveryCity, [order.deliveryState, order.deliveryZip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  const fullAddress = [addressLines, cityStateZip].filter(Boolean).join(' — ') || null;

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>Delivery Info — {order.orderNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {row('Contact', order.deliveryContactName)}
        {row('Phone', order.deliveryPhone)}
        {row('Email', order.deliveryEmail)}
        {row('Address', fullAddress)}
        {row('Delivery method', order.deliveryMethod)}
        {order.customerNotes && row('Order notes', order.customerNotes)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" size="sm" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
